import React, { useEffect } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  createCourses,
  getACourse,
  resetState,
  updateACourse,
} from "../features/courses/courseSlice";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  description: yup.string().required("Description is Required"),
  category: yup.string().required("Category is Required"),
  lecturer: yup.string().required("Lecturer is Required"),
  duration: yup.string().required("Duration is Required"),
  price: yup.number().required("Price is Required"),
   objective: yup.string().required("Objective is Required"),
  targetGroup: yup.string().required("Target Group is Required"),
});


const AddCourse = () => {
  const dispatch = useDispatch();
   const location = useLocation();
  const getCourseId = location.pathname.split("/")[3];

   const courseState = useSelector((state) => state.courses);
 
  const {
    isSuccess,
    isError,
    isLoading,
    createdCourse,
    updatedCourse,
    courseData,
  } = courseState;
 
  useEffect(() => {
    if (getCourseId !== undefined) {
      dispatch(getACourse(getCourseId));
    } else {
      dispatch(resetState());
    }
  }, [getCourseId]);

   

   

  useEffect(() => {
    if (isSuccess && createdCourse) {
      toast.success("Course Added Successfully!", { autoClose: 2000 });
      setTimeout(() => {
        window.location.href = "/admin/course-list";
      }, 2000);
    }

    if (isSuccess && updatedCourse) {
      toast.success("Course Updated Successfully!", { autoClose: 2000 });
      setTimeout(() => {
        window.location.href = "/admin/course-list";
      }, 2000);
    }

    if (isError) {
      toast.error("Something Went Wrong!", { autoClose: 2000 });
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: courseData?.title || "",
      description: courseData?.description || "",
      category: courseData?.category || "",
      lecturer: courseData?.lecturer || "",
      duration: courseData?.duration || "",
      price: courseData?.price || "",
       objective: courseData?.objective || "",
      targetGroup: courseData?.targetGroup || "",
      language: courseData?.language || "English",
      skillLevel: courseData?.skillLevel || "All Levels",
      certificate: courseData?.certificate ?? true,
      whatYouWillEarn: courseData?.whatYouWillEarn || [],
    },
    validationSchema: schema,
    onSubmit: (values) => {
    
      if (getCourseId !== undefined) {
        dispatch(updateACourse({ id: getCourseId, courseData: values }));
      } else {
        dispatch(createCourses(values));
      }
      dispatch(resetState());
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getCourseId !== undefined ? "Edit" : "Add"} Course
      </h3>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Course Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
          </div>
          <div className="error">{formik.touched.title && formik.errors.title}</div>

          <CustomInput
            type="text"
            label="Lecturer"
            name="lecturer"
            onChng={formik.handleChange("lecturer")}
            onBlr={formik.handleBlur("lecturer")}
            val={formik.values.lecturer}
          />
          <div className="error">{formik.touched.lecturer && formik.errors.lecturer}</div>

          <CustomInput
            type="text"
            label="Duration"
            name="duration"
            onChng={formik.handleChange("duration")}
            onBlr={formik.handleBlur("duration")}
            val={formik.values.duration}
          />
          <div className="error">{formik.touched.duration && formik.errors.duration}</div>

          <CustomInput
            type="number"
            label="Price"
            name="price"
            onChng={formik.handleChange("price")}
            onBlr={formik.handleBlur("price")}
            val={formik.values.price}
          />
          <div className="error">{formik.touched.price && formik.errors.price}</div>

          <CustomInput
            type="text"
            label="Objective"
            name="objective"
            onChng={formik.handleChange("objective")}
            onBlr={formik.handleBlur("objective")}
            val={formik.values.objective}
          />
          <div className="error">{formik.touched.objective && formik.errors.objective}</div>

          <CustomInput
            type="text"
            label="Target Group"
            name="targetGroup"
            onChng={formik.handleChange("targetGroup")}
            onBlr={formik.handleBlur("targetGroup")}
            val={formik.values.targetGroup}
          />
          <div className="error">{formik.touched.targetGroup && formik.errors.targetGroup}</div>

          <CustomInput
            type="text"
            label="Language"
            name="language"
            onChng={formik.handleChange("language")}
            onBlr={formik.handleBlur("language")}
            val={formik.values.language}
          />

          <CustomInput
            type="text"
            label="Skill Level"
            name="skillLevel"
            onChng={formik.handleChange("skillLevel")}
            onBlr={formik.handleBlur("skillLevel")}
            val={formik.values.skillLevel}
          />

          
         <select
            name="category"
            onChange={formik.handleChange("category")}
            onBlur={formik.handleBlur("category")}
            value={formik.values.category}
            className="form-control py-3  mt-3"
          >
            <option value="">Select Course Category</option>
            <option value="tech">Tech</option>
            <option value="design">Design</option>
          </select>
          <div className="error">{formik.touched.category && formik.errors.category}</div>


          <div className="form-check mt-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="certificate"
              name="certificate"
              checked={formik.values.certificate}
              onChange={formik.handleChange}
            />

            <label className="form-check-label" htmlFor="certificate">
              Certificate Included
            </label>
          </div>

          <label className="mt-3">What You Will Earn</label>
          <ReactQuill
            theme="snow"
            name="whatYouWillEarn"
            onChange={(value) =>
              formik.setFieldValue("whatYouWillEarn", value.split("\n").filter(Boolean))
            }
            value={(formik.values.whatYouWillEarn || []).join("\n")}
          />

       
          <label className="mt-3">About Course</label>
          <ReactQuill
            theme="snow"
            name="description"
            onChange={(value) => formik.setFieldValue("description", value)}
            value={formik.values.description}
          />
          <div className="error">{formik.touched.description && formik.errors.description}</div>

  
 

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getCourseId !== undefined ? "Edit" : "Add"} Course
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCourse;
